import { textToPath } from '@c2s-npm/plumlib';

export const textBounds = (e, font) => {
  let element = e.toJS ? e.toJS() : e;

  if (!!element.isGroup && Array.isArray(element.data)) {
    const data = element.data.find((d) => !!d.active) || element.data[0];
    element = Object.assign({}, element, data, { group: element.data });
  }

  const { data, ...props } = element;
  const args = Object.assign({}, props, { font });

  const bounds = [];
  if (!element.isGroup) {
    const { width = 0, height = 0 } = textToPath(data, args) || {};
    bounds.push({ width, height });
  } else {
    props.group.forEach((g) => {
      const { width = 0, height = 0 } = textToPath(g.data, Object.assign({}, args, g)) || {};
      bounds.push({ width, height });
    });
  }

  return bounds;
};
